import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src229751525/src/app/components/Reveal.tsx");
